import type { ComponentType } from 'react';
import type { PanelProps } from './types';

export type Stage = 'before' | 'during' | 'after';

// Smaller pieces inside a panel that another track provides (read defensively).
export type Slot = 'overviewSetup' | 'dayAgenda' | 'dayDietary' | 'checkinLinks' | 'attendanceUpload';

const panels: Record<string, ComponentType<PanelProps>> = {};
const slots: Partial<Record<Slot, ComponentType<PanelProps>>> = {};

export function registerPanel(stage: Stage, tab: string, component: ComponentType<PanelProps>) {
  panels[`${stage}.${tab}`] = component;
}

export function registerSlot(slot: Slot, component: ComponentType<PanelProps>) {
  slots[slot] = component;
}

export const registeredPanel = (stage: Stage, tab: string) => panels[`${stage}.${tab}`] ?? null;
export const slotFor = (slot: Slot) => slots[slot] ?? null;
